import { Grid } from '@mui/material';
import './ArtRequest.scss';
import ArtSimRequestForm from '../../components/ArtSimRequestForm/ArtSimRequestForm';

const SimRequest: React.FC = () => (
  <Grid className="art-request-admin__container">
    <ArtSimRequestForm mode="SIM" title="SIM Request Form" />
  </Grid>
);
export default SimRequest;
